import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, EventEmitter, Output, Input } from '@angular/core';
import { ButtonComponent, IconComponent } from '@mode/capra';
import { CompiledField } from '@mode/shared/util-switch';

@Component({
  standalone: true,
  selector: 'mode-color-confirmation-dialog',
  imports: [CommonModule, IconComponent, ButtonComponent],
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialogComponent {
  @Input() currentField!: CompiledField;
  @Output() confirmDialogActionClick = new EventEmitter<{ field: CompiledField; discardChanges: boolean }>();

  onClick(field: CompiledField, discardChanges = true) {
    this.confirmDialogActionClick.emit({ field, discardChanges });
  }
}
